import styled from 'styled-components';
import palette from '../../../lib/styles/palette';
import { useRef, useState, useEffect, useCallback } from 'react';

import { MdExpandMore, MdExpandLess, MdRemoveCircleOutline, MdAdd } from 'react-icons/md';
// import ActionButtons from '../ActionButtons';
// import AskCancelModal from '../AskCancelModal';

// import { baseWeight_anchorBolt } from "../../../lib/data/standard-weight";

const AnchorBoltForm = ({
    onSaveStructure,
    onChangeWeightSummary,
    anchorBolts,
    stringerWeight,
    trestleWeight,
    beltWidth,
}) => {
    const [isShow, setIsShow] = useState(anchorBolts?.length || false);
    const [newAnchorBolt, setNewAnchorBolt] = useState(anchorBolts || []);
    const [factor, setFactor] = useState('1.0');
    const [id, setId] = useState('');
    const [typeCategory, setTypeCategory] = useState('');
    // const [length, setLength] = useState('');
    const [baseWeight, setBaseWeight] = useState('');
    const [unitWeight, setUnitWeight] = useState('');
    const [weight, setWeight] = useState('');
    const [totalWeight, setTotalWeight] = useState('');
    // const [modal, setModal] = useState(false);
    /* 변경사항을 저장했었는지 여부에 대한 상태 저장 */
    const [isChanged, setIsChanged] = useState(false);

    const unitWeightRef = useRef({
        0: 0.016,
        1: 0.032,
    });

    /* category 설명하는 text */
    const typeCategoryText = useRef({
        0: 'For Stringer(並フレーム用)',
        1: 'For Trestle(高架支柱用)',
    });

    /*  처음 props로 넘어온 anchorBolts를 초기값 그대로 보관하고 있다가 취소 버튼을 눌렀을 때 원상 복귀 시키기 위해
        useRef를 사용하여 저장해 둔다. */
    // const initialanchorBolt = useRef(anchorBolts || []);

    /* 벨트폭에 해당하는 Weight Table을 가져온다. */
    useEffect(() => {
        // if (!baseWeight_anchorBolt || !beltWidth) return;
        // const library = baseWeight_anchorBolt.find(item => item.beltWidth === parseInt(beltWidth));
        // if (!library) {
        //     alert('Check Belt Width!!');
        //     return;
        // }
        // weightLibrary.current = library;
    }, [beltWidth]);

    /* 기준 중량 가져오기 함수 */
    // const getbaseWeight = useCallback((typeCategory) => {
    //     if (!weightLibrary.current) return;

    //     const index = typeCategory* 1;
    //     return weightLibrary.current.baseWeight[index];
    // }, []);

    /* 기준 중량 가져오기 */
    useEffect(() => {
        if (!typeCategory) return;
        setUnitWeight(unitWeightRef.current[typeCategory]);

        if (typeCategory === '0') {
            // Stringer
            setBaseWeight(Number(stringerWeight));
        } else {
            setBaseWeight(Number(trestleWeight));
        }
    }, [stringerWeight, trestleWeight, typeCategory]);

    /* 단위 중량 및 중량 자동 계산 */
    useEffect(() => {
        // if (!baseWeight || !factor || !unitWeight) {
        //     return;
        // }
        setWeight(Math.ceil(unitWeight * baseWeight * factor));
    }, [factor, baseWeight, unitWeight]);

    /* 마지막 anchorBolt ID 가져오기 함수 */
    const getLastId = useCallback(() => {
        if (!newAnchorBolt.length) {
            return 0;
        }
        return Math.max(...newAnchorBolt.map((anchorBolt) => Number(anchorBolt.id.substring(3))), 0);
    }, [newAnchorBolt]);

    /* 입력 후 폼 초기화 함수 */
    const initializeForm = useCallback(() => {
        setId(`AB-${getLastId() * 1 + 1}`);
        // setTypeCategory('');
        // setBaseWeight('');
        // setFactor('');
        // setLength('');
        setWeight('');
    }, [getLastId]);

    /* 전체 길이 계산 함수 */
    // const getTotalLength = useCallback((items) => {
    //     const _totalLength = items.reduce((accumulator, currentValue) => {
    //         return accumulator + parseInt(currentValue.length);
    //     }, 0);
    //     setTotalLength(_totalLength);
    // }, [])

    /* 전체 중량 계산 함수 */
    const getTotalWeight = useCallback((items) => {
        const _totalWeight = items.reduce((accumulator, currentValue) => {
            return accumulator + currentValue.weight;
        }, 0);
        setTotalWeight(_totalWeight);
    }, []);

    /* 추가 버튼을 누르면 newAnchorBolt에 anchorBolt 추가 */
    const onAddAnchorBolt = useCallback(() => {
        if (!unitWeight || !weight) {
            alert('Check input(s) before saving!!!');
            return;
        }
        const anchorBolt = {
            id,
            typeCategory: typeCategoryText.current[`${typeCategory}`],
            baseWeight,
            factor,
            unitWeight,
            weight,
        };
        setNewAnchorBolt((prev) => [...prev, anchorBolt]);
        setIsChanged(true);
    }, [baseWeight, factor, id, typeCategory, unitWeight, weight]);

    /* 삭제 버튼을 누르면 해당 anchorBolt 삭제 */
    const onDeleteAnchorBolt = useCallback((id) => {
        setNewAnchorBolt((prev) => prev.filter((anchorBolt) => anchorBolt.id !== id));
        setIsChanged(true);
    }, []);

    /* newAnchorBolt에 변화가 생기면 리덕스에 변경사항 쓰기 */
    useEffect(() => {
        // getTotalLength(newAnchorBolt);
        getTotalWeight(newAnchorBolt);
        initializeForm();
        onSaveStructure({
            key: 'anchorBolt',
            value: newAnchorBolt,
        });
        onChangeWeightSummary({
            key: 'anchorBolt',
            value: {
                // totalLength,
                totalWeight,
            },
        });
    }, [getTotalWeight, initializeForm, newAnchorBolt, onChangeWeightSummary, onSaveStructure, totalWeight]);

    /* Save 버튼을 누르면 리덕스에 변경사항 쓰기 */
    // const onSaveanchorBolt = useCallback(() => {
    //     onSaveStructure({
    //         key: 'anchorBolt',
    //         value: newAnchorBolt,
    //     });
    //     onChangeWeightSummary({
    //         key: 'anchorBolt',
    //         value: {
    //             totalWeight,
    //         },
    //     });
    // }, [newAnchorBolt, onChangeWeightSummary, onSaveStructure, totalWeight]);

    /* 변경 사항을 취소하면 newAnchorBolt를 초기값으로 변경하고 리덕스에 초기값으로 쓰기 */
    // const onCancelChange = useCallback(() => {
    //     setNewAnchorBolt(initialanchorBolt.current);
    //     onSaveStructure({
    //         key: 'anchorBolt',
    //         value: initialanchorBolt.current,
    //     });
    //     onChangeWeightSummary({
    //         key: 'anchorBolt',
    //         value: {},
    //     });
    //     setModal(false);
    // }, [onChangeWeightSummary, onSaveStructure]);

    /* Cancel Change 버튼을 눌렀을 때 */
    // const onClickCancel = useCallback(() => {
    //     // 저장된 적이 없다면 alert
    //     if (!isChanged) {
    //         alert('변경내용이 없습니다.');
    //         return;
    //     }
    //     setModal(true);
    // }, [isChanged]);

    return (
        <AnchorBoltFormBlock>
            <Title>
                <h3 style={{ width: '400px', margin: '0' }}>Anchor Bolt, 基礎ボルト</h3>
                <div style={{ width: '120px' }}>{/* Q'ty: {totalLength} m */}</div>
                <div style={{ width: '170px' }}>Weight: {totalWeight} kg</div>
                <div style={{ fontSize: '1.25rem', fontWeight: 'bold', display: 'flex', alignItems: 'flex-end' }}>
                    {!isShow ? (
                        <MdExpandMore color="orange" onClick={() => setIsShow(true)} />
                    ) : (
                        <MdExpandLess color="orange" onClick={() => setIsShow(false)} />
                    )}
                </div>
            </Title>
            {isShow && (
                <>
                    <table>
                        <thead>
                            <tr>
                                <th>ID.</th>
                                <th>
                                    Type <br />
                                    Category
                                </th>
                                <th>
                                    Base W't <br />
                                    (kg)
                                </th>
                                <th>
                                    Unit Weight <br /> (kg/kg)
                                </th>
                                <th>Factor</th>
                                <th>Weight(kg)</th>
                                <th></th>
                            </tr>
                        </thead>
                        <tbody>
                            {newAnchorBolt &&
                                newAnchorBolt.map((anchorBolt, index) => (
                                    <tr key={index}>
                                        <td>{anchorBolt.id}</td>
                                        <td>{anchorBolt.typeCategory}</td>
                                        <td>{anchorBolt.baseWeight}</td>
                                        <td>{anchorBolt.unitWeight}</td>
                                        <td>{anchorBolt.factor}</td>
                                        <td>{anchorBolt.weight}</td>
                                        <td className="btn-delete" onClick={() => onDeleteAnchorBolt(anchorBolt.id)}>
                                            <MdRemoveCircleOutline />
                                        </td>
                                    </tr>
                                ))}
                            <tr>
                                <td></td>
                            </tr>{' '}
                            {/* 행 사이의 간격을 띄우기 위해 */}
                            <tr>
                                <td></td>
                            </tr>{' '}
                            {/* 행 사이의 간격을 띄우기 위해 */}
                            <tr className="input-form">
                                {/* <td><StyledInput readOnly value={id} onChange={(e) => setId(e.target.value)} /></td> */}
                                <td className="id-column">{id}</td>
                                <td>
                                    <div className="input-radio">
                                        <label>
                                            <input
                                                type="radio"
                                                name="typeCategory"
                                                value="0"
                                                onChange={(e) => setTypeCategory(e.target.value)}
                                            />
                                            <span>For Stringer(並フレーム用)</span>
                                        </label>
                                        <label>
                                            <input
                                                type="radio"
                                                name="typeCategory"
                                                value="1"
                                                onChange={(e) => setTypeCategory(e.target.value)}
                                            />
                                            <span>For Trestle(高架支柱用)</span>
                                        </label>
                                    </div>
                                </td>
                                <td>
                                    <StyledInput
                                        placeholder="..."
                                        value={baseWeight}
                                        onChange={(e) => setBaseWeight(e.target.value)}
                                    />
                                </td>
                                <td>
                                    <StyledInput
                                        placeholder="..."
                                        value={unitWeight}
                                        onChange={(e) => setUnitWeight(e.target.value)}
                                    />
                                </td>
                                <td>
                                    <StyledInput
                                        placeholder="..."
                                        value={factor}
                                        onChange={(e) => setFactor(e.target.value)}
                                    />
                                </td>
                                <td className="total-weight">{weight}</td>
                                <td className="btn-add" onClick={onAddAnchorBolt}>
                                    <MdAdd />
                                </td>
                            </tr>
                        </tbody>
                        <tfoot>
                            <tr>
                                <td colSpan={5}>anchorBolt Total</td>
                                {/* <td>{totalLength}</td> */}
                                <td>{totalWeight}</td>
                            </tr>
                        </tfoot>
                    </table>
                    {/* <ActionButtons confirmText="Save" cancelText="Cancel Change" onConfirm={onSaveanchorBolt} onCancel={onClickCancel} /> */}
                    {/* <AskCancelModal visible={modal} onConfirm={onCancelChange} onCancel={() => setModal(false)} /> */}
                </>
            )}
        </AnchorBoltFormBlock>
    );
};

/* =================   Styles   ================== */
const Title = styled.div`
    display: flex;
    align-items: flex-end;
    margin-bottom: 1rem;

    color: ${palette.cyan[6]};
`;

const AnchorBoltFormBlock = styled.div`
    // max-width: 1280px;
    // margin: 0 auto;
    // margin: 0 2rem;
    .btn-delete {
        color: ${palette.cyan[6]};
        font-size: 1rem;
        cursor: pointer;
        padding: 0 1rem;
        padding-top: 0.3rem;
        &:hover {
            color: ${palette.cyan[4]};
        }
    }
    .btn-add {
        color: ${palette.cyan[6]};
        font-size: 1.5rem;
        cursor: pointer;
        padding: 0;
        padding-top: 0.4rem;
        &:hover {
            color: ${palette.cyan[4]};
        }
    }
    table {
        width: 100%;
        font-size: 0.9rem;
        border-collapse: collapse;
    }
    thead {
        border-top: 1px solid ${palette.gray[4]};
        border-bottom: 1px solid ${palette.gray[4]};
        color: ${palette.gray[7]};
    }
    tfoot {
        border-top: 1px solid ${palette.gray[4]};
        border-bottom: 1px solid ${palette.gray[4]};
        height: 2.5rem;
        font-weight: bold;
        color: ${palette.gray[7]};
    }
    th {
        padding: 0.5rem 0.25rem;
        text-align: center;
    }
    td {
        padding: 0.25rem 0.25rem;
        text-align: center;
    }
    .td-radio {
        display: flex;
        justify-content: center;
        // margin: 0 auto;
    }
    .input-radio {
        display: flex;
        flex-direction: column;
        // margin: 0 auto;
        align-items: flex-start;
        span {
            margin-left: 0.5rem;
        }
        // 추가함
        label + label {
            margin-top: 0.25rem;
        }
    }
    h3 {
        color: ${palette.cyan[6]};
    }
    .input-form {
        background-color: ${palette.gray[0]};
    }
    .right-align {
        text-align: right;
    }
`;

const StyledInput = styled.input`
    border: none;
    outline: none;
    padding: 0.25rem 0.5rem;
    width: 50px;
    text-align: center;
    background: transparent;
    &:hover {
        background: ${palette.gray[3]};
    }
`;

export default AnchorBoltForm;
